import {
  characterBounds,
  characterNameBounds,
  characterPortraitBounds,
} from "../bounds";
import type { BoardModelDebugMeasurable } from "../measurable";

export function characterMeasurable(characterId: string): BoardModelDebugMeasurable {
  return {
    kind: "Character",
    debugId: characterId,
    measure: (context) => characterBounds(context.labelsRoot, characterId),
  };
}

export function characterPortraitMeasurable(
  characterId: string,
): BoardModelDebugMeasurable {
  return {
    kind: "CharacterPortrait",
    debugId: characterId,
    measure: (context) =>
      characterPortraitBounds(context.labelsRoot, characterId),
  };
}

export function characterNameMeasurable(
  characterId: string,
): BoardModelDebugMeasurable {
  return {
    kind: "CharacterName",
    debugId: characterId,
    measure: (context) => characterNameBounds(context.labelsRoot, characterId),
  };
}
